import React from "react";
import styles from "./Header.module.scss";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

export const Header = ({ overviewStyle }: { overviewStyle: boolean }) => {
  return (
    <div
      className={`${styles.container} ${
        !overviewStyle && styles.stylishContainer
      }`}
    >
      <div className={styles.leftHeaderSection}>
        <a className={styles.linkTxt} href="mailto:mcsd1969@gmail.com">
          <EmailIcon className={styles.icon} />
        </a>
      </div>
      <div className={styles.rightHeaderSection}>
        <div className={styles.iconContainer}>
          <a className={styles.linkTxt} href="tel:+9983688849">
            <WhatsAppIcon className={styles.icon} />
          </a>
        </div>
        <LinkedInIcon className={styles.icon} />
        <InstagramIcon className={styles.icon} />
        <FacebookIcon className={styles.icon} />
      </div>
    </div>
  );
};
